// import { useEffect, useState } from "react";
// import {
//   API_DISTRICTS,
//   API_SUB_COUNTIES,
//   API_COUNTIES,
//   API_PARISHES,
//   API_VILLAGES,
// } from "../../utils/apis";
// import axios from "axios";
// import { BASE_API_URL } from "../../config";
// import { useAuth } from "../../context/AuthContext";

export const useLocationDataForm = () => {
  // const [districts, setDistricts] = useState([]);
  // const [counties, setCounties] = useState([]);
  // const [sub_counties, setSubCounties] = useState([]);
  // const [parishes, setParishes] = useState([]);
  // const [villages, setVillages] = useState([]);

  // const { authToken } = useAuth();

  // const [districtsLoading, setDistrictsLoading] = useState(false);
  // const [countiesLoading, setCountiesLoading] = useState(false);
  // const [subCountiesLoading, setSubCountiesLoading] = useState(false);
  // const [parishesLoading, setParishesLoading] = useState(false);
  // const [villagesLoading, setVillagesLoading] = useState(false);

  // const dataCall = (api: any, fallback: any, params: any, setLoading: any) => {
  //   const API = `${BASE_API_URL}${api}`;
  //   setLoading(true);
  //   axios
  //     .get(API, {
  //       headers: {
  //         "Content-Type": "application/json",
  //         ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
  //       },
  //       params: { ...params },
  //     })
  //     .then(({ data }) => {
  //       // handle success
  //       fallback(
  //         Array.isArray(data) ? data : data?.data || data?.results || [],
  //       );
  //       setLoading(false);
  //     })
  //     .catch(() => {
  //       setLoading(false);
  //       // handle error
  //     });
  // };

  // const getDistricts = () => {
  //   dataCall(API_DISTRICTS, setDistricts, null, setDistrictsLoading);
  // };

  // const getCounties = (parent_district: any) => {
  //   dataCall(
  //     API_COUNTIES,
  //     setCounties,
  //     { parent: parent_district },
  //     setCountiesLoading,
  //   );
  // };

  // const getSubCounties = (parent_county: any) => {
  //   dataCall(
  //     API_SUB_COUNTIES,
  //     setSubCounties,
  //     { parent: parent_county },
  //     setSubCountiesLoading,
  //   );
  // };

  // const getParishes = (parent_sub_county: any) => {
  //   dataCall(
  //     API_PARISHES,
  //     setParishes,
  //     { parent: parent_sub_county },
  //     setParishesLoading,
  //   );
  // };

  // const getVillages = (parent_parish: any) => {
  //   dataCall(
  //     API_VILLAGES,
  //     setVillages,
  //     { parent: parent_parish },
  //     setVillagesLoading,
  //   );
  // };

  // useEffect(() => {
  //   getDistricts();
  // }, []);

  // useEffect(() => {
  //   if (form.district) getCounties(form.district);
  // }, [form.district]);

  // useEffect(() => {
  //   if (form.county) getSubCounties(form.county);
  // }, [form.county]);

  // useEffect(() => {
  //   if (form.sub_county) getParishes(form.sub_county);
  // }, [form.sub_county]);

  // useEffect(() => {
  //   if (form.parish) getVillages(form.parish);
  // }, [form.parish]);

  const fields = (required = false) => {
    return [
      // {
      //   field_name: "district",
      //   type: "select",
      //   label: "District",
      //   options_data: districts,
      //   loading: districtsLoading,
      //   props: { required: required, smallWidth: true },
      // },
      // {
      //   field_name: "county",
      //   type: "select",
      //   label: "County",
      //   options_data: counties,
      //   loading: countiesLoading,
      //   props: { required: required, smallWidth: true },
      // },
      // {
      //   field_name: "sub_county",
      //   type: "select",
      //   label: "Sub County",
      //   options_data: sub_counties,
      //   loading: subCountiesLoading,
      //   props: { required: required, smallWidth: true },
      // },
      // {
      //   field_name: "parish",
      //   type: "select",
      //   label: "Parish",
      //   options_data: parishes,
      //   loading: parishesLoading,
      //   props: { required: required, smallWidth: true },
      // },
      // {
      //   field_name: "village",
      //   type: "select",
      //   label: "Village",
      //   options_data: villages,
      //   loading: villagesLoading,
      //   props: { required: required, smallWidth: true },
      // },
      {
        field_name: "physical_address",
        type: "text",
        label: "Physical Address",
        description:
          "Enter the full and accurate physical location where you or the business can be found. Include details such as building name, street, village, parish, or district.",
        props: { required: required },
      },
    ];
  };

  return {
    fields,
    // options: {
    //   districts: districts,
    //   counties: counties,
    //   sub_counties: sub_counties,
    //   parishes: parishes,
    //   villages: villages,
    // },
  };
};
